// src/components/Layout/Footer.jsx
import React from 'react';
import { Github, Globe, Instagram } from 'lucide-react';

export const Footer = ({ className = '' }) => {
  return (
    <footer
      className={`py-8 mt-12 bg-white/5 dark:bg-white/5 backdrop-blur-xl border-t border-white/10 ${className}`}
    >
      <div className="max-w-6xl mx-auto px-6 text-center">
        <div className="flex justify-center gap-6 mb-4">
          <a
            href="https://ashita.africa"
            target="_blank"
            rel="noreferrer"
            className="p-2 bg-white/10 rounded-xl border border-white/10 hover:bg-white/20 transition"
          >
            <Globe className="w-5 h-5 text-amber-300" />
          </a>

          <a
            href="https://github.com/ashita"
            target="_blank"
            rel="noreferrer"
            className="p-2 bg-white/10 rounded-xl border border-white/10 hover:bg-white/20 transition"
          >
            <Github className="w-5 h-5 text-amber-300" />
          </a>

          <a
            href="#"
            className="p-2 bg-white/10 rounded-xl border border-white/10 hover:bg-white/20 transition"
          >
            <Instagram className="w-5 h-5 text-amber-300" />
          </a>
        </div>

        <p className="text-sm opacity-80 text-slate-700 dark:text-slate-300">
          © {new Date().getFullYear()} — Developed by{' '}
          <a
            href="https://ashita.africa"
            className="text-amber-300 hover:underline"
            target="_blank"
            rel="noreferrer"
          >
            Ashita Creatives
          </a>
        </p>
      </div>
    </footer>
  );
};
